import { render } from "./EventDesignPreview.vue?vue&type=template&id=0a9582cf"
import script from "./EventDesignPreview.vue?vue&type=script&lang=js"
export * from "./EventDesignPreview.vue?vue&type=script&lang=js"

import "./EventDesignPreview.vue?vue&type=style&index=0&id=0a9582cf&lang=css"

import exportComponent from "C:\\Users\\bfern\\Documents\\la-vuelta-trama\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__